module.exports = __webpack_public_path__ + "static/img/hair_16.ca81dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_16.png
// module id = hlqB
// module chunks = 0